import React, { useEffect, useSyncExternalStore } from 'react';
import { subscribeToasts, getToastsSnapshot, dismissToast } from '../utils/toast';
import './ToastHost.css';

// Same toast as ProPlan Connect and Pursuit Connect: a tinted card in the
// top-right corner with a type icon, the message, and a dismiss button.
const ICON_BY_TYPE = {
  success: 'bi-check-circle-fill',
  error: 'bi-x-circle-fill',
  warning: 'bi-exclamation-triangle-fill',
  info: 'bi-info-circle-fill',
};

function ToastItem({ toast }) {
  const type = ICON_BY_TYPE[toast.type] ? toast.type : 'info';

  useEffect(() => {
    if (!(toast.duration > 0)) return undefined;
    const timer = setTimeout(() => dismissToast(toast.id), toast.duration);
    return () => clearTimeout(timer);
  }, [toast.id, toast.duration]);

  return (
    <div
      className={`ui-toast ui-toast--${type}${toast.leaving ? ' ui-toast--leaving' : ''}`}
      role={type === 'error' ? 'alert' : 'status'}
    >
      <i className={`bi ${ICON_BY_TYPE[type]} ui-toast__icon`} aria-hidden="true" />
      <div className="ui-toast__message">
        {toast.header && <div className="ui-toast__header">{toast.header}</div>}
        {toast.content}
      </div>
      <button
        type="button"
        className="ui-toast__close"
        aria-label="Dismiss"
        onClick={() => dismissToast(toast.id)}
      >
        <i className="bi bi-x-lg" aria-hidden="true" />
      </button>
    </div>
  );
}

export default function ToastHost() {
  const toasts = useSyncExternalStore(subscribeToasts, getToastsSnapshot, getToastsSnapshot);

  if (toasts.length === 0) return null;

  return (
    <div className="ui-toast-stack">
      {toasts.map((t) => <ToastItem key={t.id} toast={t} />)}
    </div>
  );
}
